var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendEmail = function SvgSendEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5733 4.07921C30.3959 4.02764 30.2082 4 30.0142 4H2.01416C1.81602 4 1.62461 4.02881 1.4439 4.08248L15.2755 18.9221C15.6709 19.3463 16.3431 19.3463 16.7385 18.9221L30.5733 4.07921Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0675268 5.5391C0.0326265 5.68707 0.0141602 5.84138 0.0141602 6V25.4898C0.0141602 25.69 0.0435741 25.8833 0.098316 26.0657L9.68689 15.8595L0.0675268 5.5391Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55444 27.4367C1.70205 27.4715 1.85596 27.4898 2.01416 27.4898H30.0142C30.1735 27.4898 30.3286 27.4712 30.4772 27.436L20.9553 17.3313L18.2015 20.2858C17.0153 21.5585 14.9987 21.5585 13.8124 20.2858L11.0535 17.3258L1.55444 27.4367Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.931 26.0624C31.9851 25.881 32.0142 25.6888 32.0142 25.4898V6C32.0142 5.83705 31.9947 5.67865 31.9579 5.52701L22.3219 15.8652L31.931 26.0624Z",
    fill: "currentColor"
  })));
};
export default SvgSendEmail;